var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"plug_service am-animation-slide-bottom"},[_c('ul',[_c('li',{on:{"click":_vm.to}},[_vm._m(0)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',[_c('img',{staticStyle:{"width":"35px","height":"35px"},attrs:{"src":"https://railway-park.oss-cn-shanghai.aliyuncs.com/business/broker/2023/07/1690029781117.svg"}}),_c('div',[_vm._v("热销产品")])])
}]

export { render, staticRenderFns }